export default {
    DISABLE_PROMPT(state) {
        state.showPrompt = false;
    },
};
